"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const store_1 = require("../../context/store");
const actions_1 = require("../../context/actions");
const styles_1 = require("./styles");
const SearchIcon_1 = __importDefault(require("../Icons/SearchIcon"));
const SearchBar = ({ searchType, setSearchResult }) => {
    const inputRef = (0, react_1.useRef)(null);
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const [searchQuery, setSearchQuery] = (0, react_1.useState)("");
    const dispatch = (0, store_1.useDispatch)();
    const handleChange = (0, react_1.useCallback)((query) => {
        setSearchQuery(query);
        setSearchResult(query);
        if (query === "icantdothatdave") {
            dispatch({ type: actions_1.CONTEXT_ACTIONS.TOGGLE_DEBUG });
        }
    }, [dispatch, setSearchResult]);
    const selectInput = (0, react_1.useCallback)(() => {
        if (!inputRef.current)
            return;
        inputRef.current.select();
    }, []);
    (0, react_1.useEffect)(() => {
        selectInput();
    }, [selectInput]);
    return (react_1.default.createElement(styles_1.InputWrapper, null,
        react_1.default.createElement(SearchIcon_1.default, { height: 16, width: 16, onClick: selectInput }),
        react_1.default.createElement(styles_1.StyledInput, { type: "text", placeholder: formatMessage({ id: `buy.${searchType}-placeholder` }), value: searchQuery, onChange: (e) => {
                handleChange(e.target.value);
            }, ref: inputRef })));
};
exports.default = SearchBar;
//# sourceMappingURL=SearchBar.js.map